<template>
    <div class="car-rental-info">
        这是租车详情
    </div>
</template>
<script>
    export default {
        name:'RentalInfo',
    }
</script>